var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrench = function SvgWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wrench_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.167 8a7.5 7.5 0 0 1-8.952 7.36c-.453-.09-.93.022-1.256.348l-7.917 7.917a3.536 3.536 0 0 1-5-5l7.917-7.917c.326-.326.437-.803.348-1.256A7.5 7.5 0 0 1 19.91.842c.417.13.514.65.205.96l-4.323 4.323.625 3.125 3.125.625 4.323-4.323c.309-.31.83-.212.96.205.222.708.342 1.462.342 2.243ZM5.792 21.125a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wrench_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.167 .5)",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgWrench;